import { useState } from "react";
import { BrandMark } from "./components/BrandMark";
import { Download } from "./sections/Download";
import { DocsHub } from "./sections/DocsHub";
import { Home } from "./sections/Home";
import { HowItWorks } from "./sections/HowItWorks";
import { Product } from "./sections/Product";
import { TechnicalOverview } from "./sections/TechnicalOverview";
import { TrustLimits } from "./sections/TrustLimits";
import { SITE_VERSION } from "./version";

const SENDER_URL = import.meta.env.DEV ? "http://localhost:5173" : "/send";

const NAV = [
  { href: "#home", label: "Home" },
  { href: "#product", label: "Receiver" },
  { href: "#how-it-works", label: "How it works" },
  { href: "#download", label: "Download" },
  { href: "#docs", label: "Docs" },
  { href: "#trust", label: "Trust" },
] as const;

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="site-shell">
      <header className="site-nav">
        <a className="nav-brand" href="#home">
          <BrandMark size={28} />
          PairBolt
          <span className="nav-version" title="Current release">
            v{SITE_VERSION}
          </span>
        </a>

        <button
          type="button"
          className="mobile-nav-toggle"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen((o) => !o)}
        >
          Menu
        </button>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          {NAV.map((item) => (
            <li key={item.href}>
              <a href={item.href} onClick={() => setMenuOpen(false)}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="nav-cta">
          <a className="btn btn-outline" href="#download">
            Download
          </a>
          <a className="btn btn-primary" href={SENDER_URL}>
            Start transfer
          </a>
        </div>
      </header>

      <main>
        <Home senderUrl={SENDER_URL} />
        <Product />
        <HowItWorks />
        <TechnicalOverview />
        <Download senderUrl={SENDER_URL} />
        <DocsHub />
        <TrustLimits />
      </main>

      <footer className="site-footer">
        <p>
          © 2026 <a href="https://pairbolt.com">pairbolt.com</a> · Apache-2.0 ·{" "}
          <a href="#download">v{SITE_VERSION}</a>
        </p>
        <p>Free · Direct · Private · No cloud storage · No third-party scripts</p>
      </footer>
    </div>
  );
}
